import { FC, useState } from 'react';
import { SearchInput } from './search-input';
import { SearchResult } from './search-result';

export const SearchSugBody: FC = () => {
  const [query, setQuery] = useState('');

  const onQueryChange = (str: string): void => {
    setQuery(str);
  };

  return (
    <>
      <SearchInput onQueryChange={onQueryChange} />
      <SearchResult query={query} />
    </>
  );
};
